import { render, staticRenderFns } from "./DeleteIconButton.vue?vue&type=template&id=1b1c7383&"
import script from "./DeleteIconButton.vue?vue&type=script&lang=js&"
export * from "./DeleteIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports